import type { HTMLProps, MouseEvent, ReactElement, ReactNode } from "react";
import { cloneElement, forwardRef } from "react";

import { useDrawer } from "../providers";

interface DrawerTriggerProps extends HTMLProps<"button"> {
  children: ReactElement;
}

type ComponentProps = { onClick?: (event: MouseEvent) => void; children?: ReactNode; [key: string]: unknown };

export const DrawerTrigger = forwardRef<HTMLButtonElement, DrawerTriggerProps>((props, ref) => {
  const { openDrawer } = useDrawer();

  const Component: ReactElement<ComponentProps> = Array.isArray(props.children) ? props.children[0] : props.children;
  const componentProps = Component.props;
  const mergedOnClick = (event: MouseEvent) => {
    componentProps?.onClick?.(event);
    openDrawer();
  };
  const mergedProps = { ...componentProps, onClick: mergedOnClick, ref };

  return cloneElement(Component, mergedProps, componentProps.children);
});

DrawerTrigger.displayName = "DrawerTrigger";
